import { hipotecarioBeneficios } from './beneficios';
import { hipotecarioCTV } from './ctv';

export const HIPOTECARIO_TEMPLATES = [hipotecarioBeneficios, hipotecarioCTV] as const;

export * from './beneficios';
export * from './ctv';
